import {Person} from './person';
import {Address} from './address';

export class UpdatePersonRequest {
  person: Person;
  billingAddress: Address;
  postalAddress: Address;
}
